import { render, staticRenderFns } from "./MondayTemplateList.vue?vue&type=template&id=328f764a&scoped=true&"
import script from "./MondayTemplateList.vue?vue&type=script&lang=js&"
export * from "./MondayTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./MondayTemplateList.vue?vue&type=style&index=0&id=328f764a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f764a",
  null
  
)

export default component.exports